export default __webpack_public_path__ + "static/hi-mum-dad-scam-3d59787b76ae39e6455446483f1d2015.webp";